<template>
  <div>
    <div class="flex flex-col sm:hidden mx-auto justify-center items-center m-8">
      <div class="mb-2">
        <p class="text-lg"><b>Comienza tu pedido</b></p>
      </div>
      <vs-button class="mx-8" size="large" color="primary" @click="setDeliverOrder">Entrega a domicilio</vs-button>
      <h2>o</h2>
      <vs-button class="mx-8" size="large" color="primary" @click="setCarryOutOrder">Recoger en tienda</vs-button>
    </div>

    <div class="hidden sm:flex mx-auto justify-center items-center m-8">
      <p class="text-2xl ml-8">Comienza tu pedido</p>
      <vs-button class="mx-8" size="large" color="primary" @click="setDeliverOrder">Entrega a domicilio</vs-button>
      <h2>o</h2>
      <vs-button class="mx-8" size="large" color="primary" @click="setCarryOutOrder">Recoger en tienda</vs-button>
    </div>

    <div v-if="typeof showcaseProducts != 'undefined' && showcaseProducts.length > 0" class="grid grid-rows-2 grid-cols-3 gap-4 mx-4 lg:mx-20 mb-base">
      <div class="row-span-2 col-span-3 md:col-span-2">
        <img :src="getShowcaseImage(showcaseProduct1, 0)" alt="showcase1" class="responsive cursor-pointer" @click="goToProduct(showcaseProduct1)">
<!--        <vx-card class="overflow cursor-pointer rounded-lg" @click="goToProduct(showcaseProduct1)">-->
<!--          <div slot="no-body" style="background-color: #F8F8F8;">-->
<!--            <img :src="getShowcaseImage(showcaseProduct1, 400)" alt="showcase1" class="responsive card-img-top bg-transparent" style="object-fit: cover;">-->
<!--            <div class="card-overlay flex flex-col justify-between">-->
<!--              <div class="flex justify-center flex-wrap">-->
<!--                <p class="text-small lg:text-3xl mt-2 text-bold bg-white p-4" style="border-radius: 30px;" v-if="showcaseProduct1.price > 0"><b>Q{{showcaseProduct1.price.toFixed(2)}}</b></p>-->
<!--              </div>-->
<!--              <vs-spacer/>-->
<!--              <p class="text-sm md:text-xl text-white text-center xl:text-left"><b>{{showcaseProduct1.name}}</b></p>-->
<!--              <p class="hidden xl:block mt-2 text-white">{{showcaseProduct1.description}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </vx-card>-->
      </div>
      <div class="row-span-1 col-span-3 md:col-span-1">
        <img :src="getShowcaseImage(showcaseProduct2, 400)" alt="showcase2" class="responsive cursor-pointer" @click="goToProduct(showcaseProduct2)">
<!--        <vx-card class="overflow cursor-pointer" @click="goToProduct(showcaseProduct2)">-->
<!--          <div slot="no-body">-->
<!--            <img :src="getShowcaseImage(showcaseProduct2, 200)" alt="showcase2" class="responsive card-img-top" style="object-fit: cover;">-->
<!--            <div class="card-overlay flex flex-col justify-between">-->
<!--              <div class="flex justify-center flex-wrap">-->
<!--                <p class="text-small lg:text-xl mt-2 text-bold bg-white p-4" style="border-radius: 30px;" v-if="showcaseProduct2.price > 0"><b>Q{{showcaseProduct2.price.toFixed(2)}}</b></p>-->
<!--              </div>-->
<!--              <vs-spacer/>-->
<!--              <p class="text-sm md:text-xl text-white text-center xl:text-left"><b>{{showcaseProduct2.name}}</b></p>-->
<!--              <p class="hidden xl:block mt-2 text-white">{{showcaseProduct2.description}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </vx-card>-->
      </div>
      <div class="row-span-1 col-span-3 md:col-span-1">
        <img :src="getShowcaseImage(showcaseProduct3, 400)" alt="showcase3" class="responsive cursor-pointer" @click="goToProduct(showcaseProduct3)">
<!--        <vx-card class="overflow cursor-pointer" @click="goToProduct(showcaseProduct3)">-->
<!--          <div slot="no-body">-->
<!--            <img :src="getShowcaseImage(showcaseProduct3, 200)" alt="showcase3" class="responsive card-img-top" style="object-fit: cover;">-->
<!--            <div class="card-overlay flex flex-col justify-between">-->
<!--              <div class="flex justify-center flex-wrap">-->
<!--                <p class="text-small lg:text-xl mt-2 text-bold bg-white p-4" style="border-radius: 30px;" v-if="showcaseProduct3.price > 0"><b>{{showcaseProduct3.price.toFixed(2)}}</b></p>-->
<!--              </div>-->
<!--              <vs-spacer/>-->
<!--              <p class="text-sm md:text-xl text-white text-center xl:text-left"><b>{{showcaseProduct3.name}}</b></p>-->
<!--              <p class="hidden xl:block mt-2 text-white">{{showcaseProduct3.description}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </vx-card>-->
      </div>
    </div>
  </div>
</template>

<script>
  // import {CldImage} from 'cloudinary-vue';
  // import {db} from '@/firebaseConfig'

  export default {
    data() {
      return {
        loaded: false,
        screens: [
          {min: 0, max: 575, height: 120},     // xs
          {min: 576, max: 767, height: 185},   // sm
          {min: 768, max: 991, height: 250},   // md
          {min: 992, max: 1199, height: 330},  // lg
          {min: 1200, max: 1399, height: 400}, // xl
          {min: 1400, max: 1599, height: 480}, // 1xl (antes 480)
          {min: 1600, max: 8000, height: 535}  // xxl (antes 535)
        ]
      }
    },
/*
    components: {
      CldImage
    },
*/
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      viewPort() {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      },
      innerWidth() {
        return (window.innerWidth || 0);
      },
      cloudName() {
        return this.$store.getters['getParameter']('cloudinary').cloudName;
      },
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
        imageHeight() {
        if (this.windowWidth < 992) {
          return 150;
        } else {
          return 220;
        }
      },
      showcaseProducts() {
        return this.$store.getters.showcaseProducts;
      },
      visibleShowcaseProducts() {
        return this.getVisibleShowcaseProducts();
      },
      showcaseProduct1() {
        return this.showcaseProducts[0];
      },
      showcaseProduct2() {
        return this.showcaseProducts[1];
      },
      showcaseProduct3() {
        return this.showcaseProducts[2];
      }
    },
    methods: {
/*
      getImage(product, height) {
        var image = '';
        if (product) {
          if (product.hasOwnProperty('imageURL')) {
            image = `https://res.cloudinary.com/${this.cloudName}/image/upload/dpr_auto,h_${height},w_auto,c_scale/${product.imageURL}`;
          }
        }
        return image;
      },
*/
      getShowcaseImage(item, height) {
        const image = item.imageURL.split('.');
        let imageURL = [this.imagesURL, '/showcase%2F', image[0], '@', height, '.', image[1], '?alt=media'].join('');
        if (height == 0) {
          imageURL = [this.imagesURL, '/showcase%2F', image[0], '.', image[1], '?alt=media'].join('');
        }
        return imageURL;
      },
      setDeliverOrder() {
        this.$store.dispatch('updateDeliveryType',  'delivery');
        this.$router.push({ name: 'locations' });
      },
      setCarryOutOrder() {
        this.$store.dispatch('updateDeliveryType',  'carryOut');
        this.$router.push({ name: 'locations' });
      },
      goToProduct(item) {
        if (item.productId != '') {
          const product = this.$store.getters['getProduct'](item.productId);
          if (product) {
            const category = this.$store.getters.getCategory(product.categories.split(',')[0]).name.CIAI().toLowerCase().replace(/ /g, '-');
            this.$router.push({
              name: 'item-detail-view',
              params: {
                category: category,
                item: product.name.CIAI().toLowerCase().replace(/ /g, '-')
              }
            }).catch(() => { });
          }
        } else if (item.categoryId != '') {
          const category = this.$store.getters['getCategory'](item.categoryId);
          if (category) {
            this.$router.push({name: 'category-view', params: {category: category.name.CIAI().toLowerCase().replace(/ /g, '-')}});
          }
        }
      }
    },
    mounted() {
      this.loaded = true;
    }
  }
</script>

<style lang="scss">
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .8s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
